<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" :pageData="pageData"></table-page>
  </div>
</template>

<script>
import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import DateUtil from '@/utils/IM/tradeDataUtil.js'
import Qs from 'qs'
import Url from '@/views/crs/util/url'
import UPDATE from '@/components/page/update'

let symbolTypes = {
  2: '外汇',
  3: '参考',
  4: '商品',
  5: '指数',
  6: '虚拟币',
  7: '股票',
}

export default {
  name: 'list',
  components: {
    tablePage,
    FORM
  },
  created() {

  },
  methods: {

    /*查询表单按钮点击事件*/
    formclick(clickName, data) {
      if (window.$t('common.search') == clickName || '查询' == clickName) {
        this.queryData = data
        this.$refs.childTable.defaultGetData(data)
      }
    },

    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        this.$refs.childTable.defaultGetData(this.queryData)
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    }

  },
  data() {
    return {
      queryData: {},
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          {
            title: 'businessTypeAlias',
            field: 'businessTypeAlias',
            data: DateUtil.getParamKey(this.$route.params),
            hidden: true
          },
          { title: '賬號', field: 'customerNumber', isNumber: true },
          {
            title: '交易產品類型',
            field: 'symbolType',
            type: 2,
            optionList: symbolTypes,
            multiple: false
          },
          {
            title: '開始時間',
            field: 'startTime',
            type: 5,
            format: 'yyyy-MM-dd HH:mm:ss'
          },
          {
            title: '結束時間',
            field: 'endTime',
            type: 5,
            format: 'yyyy-MM-dd HH:mm:ss'
          },
          { click: window.$t('common.search') }
        ]
      },
      /*table生成*/
      pageData: {
        isShow: false,
        queryUrl: Url.quantityTask.tradeList,
        selection: false,
        sequence: true,
        method: 'get',
        cols: [
          { title: window.$t('crs.quantityTask.customerNumber'), field: 'customerNumber' },
          {
            title: '交易時間', field: 'excTime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          { title: '交易手數', field: 'excVolume' },
          { title: '交易產品', field: 'symbol' },
          { title: '交易產品類型', field: 'symbolType' },
          { title: '業務類型', field: 'businessType' }
        ]
      }
    }
  }
}
</script>
